import {KnowledgeRagTopic} from 'common/src/modules/ai/ai.enums';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import adBuilderContext from 'common/src/modules/creativeTemplates/copilot/context/adBuilderContext';
import creativeTemplatePageContext from 'common/src/modules/creativeTemplates/copilot/context/creativeTemplatePageContext';
import addLayer2Tool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/addLayer2Tool';
import addOrEditTextAnimatorTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/addOrEditTextAnimatorTool';
import deleteLayersTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/deleteLayersTool';
import duplicateLayersTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/duplicateLayersTool';
import editLayerContentTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/editLayerContentTool';
import editLayerTransform2Tool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/editLayerTransform2Tool';
import extractTextLayersFromImageTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/extractTextLayersFromImageTool';
import getAvailableAssetsTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/getAvailableAssetsTool';
import getLayerDetailsTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/getLayerDetailsTool';
import getTransitionDescriptionAndInstructionsTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/getTransitionDescriptionAndInstructionsTool';
import importAssetFromBrandAssetsTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/importAssetFromBrandAssetsTool';
import letUserSeeOrSelectAssetTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/letUserSeeOrSelectAssetTool';
import promptToImageTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/promptToImageTool';
import selectLayersTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/selectLayersTool';
import updateLayerGeneralParamsTool from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/tools/updateLayerGeneralParamsTool';
import selectAssetsTool from 'common/src/modules/shared/copilot/tools/selectAssetsTool/selectAssetsTool';
import skill from 'common/src/modules/shared/copilot/utils/creators/skill';
import {CLStore} from 'common/src/redux/store';
import {SkillName} from '../skills.enums';

function adBuilderSkill(store: CLStore) {
  return skill({
    name: SkillName.AdBuilder,
    description:
      'Manages ad composition layers — create, edit, delete, duplicate layers with transforms, effects, animations, and assets',
    whenToUse:
      'Building and editing ad compositions inside a creative template. Handles managing layers including text, image, video, and shape layers. Can add, edit, delete, and duplicate layers, adjust transforms like position, size, rotation, and opacity, apply effects and animations, manage text animators and transitions, and work with template assets from the asset library or brand assets. Can also generate images from prompts and extract text layers from images.',
    whenToAvoid:
      'Managing templates at the library level (creating, duplicating, renaming templates) — that is the creative templates manager skill.',
    instructions:
      'Help the user build and edit ad compositions. You can add, edit, delete, and duplicate layers (text, image, video, shape). You can manage layer transforms, effects, animations, and work with template assets.',
    tools: [
      addLayer2Tool(store),
      getAvailableAssetsTool(store),
      letUserSeeOrSelectAssetTool(),
      selectAssetsTool(),
      editLayerTransform2Tool(store),
      deleteLayersTool(store),
      duplicateLayersTool(store),
      getLayerDetailsTool(store),
      promptToImageTool(store),
      importAssetFromBrandAssetsTool(store),
      updateLayerGeneralParamsTool(store),
      selectLayersTool(store),
      addOrEditTextAnimatorTool(store),
      getTransitionDescriptionAndInstructionsTool(),
      editLayerContentTool(store),
      extractTextLayersFromImageTool(store),
    ],
    contextBuilders: [
      creativeTemplatePageContext(store),
      adBuilderContext(store),
    ],
    knowledgeTopics: [KnowledgeRagTopic.AdBuilderAgent],
    applicableBreadcrumbs: [BreadcrumbName.AdBuilder],
  });
}

export default adBuilderSkill;
